import React from "react";
import { Link } from "react-router-dom";
import classes from "./Button.module.css";

const Button = () => {
  return (
    <div className={classes.btn}>
      <Link to="/contacts">Connect</Link>
    </div>
  );
};

export default Button;
